const COGNITO_DOMAIN = import.meta.env.VITE_COGNITO_DOMAIN;
const CLIENT_ID = import.meta.env.VITE_COGNITO_CLIENT_ID;
const REDIRECT_URI = import.meta.env.VITE_COGNITO_REDIRECT_URI;
const LOGOUT_URI = import.meta.env.VITE_COGNITO_LOGOUT_URI;
const SCOPES = import.meta.env.VITE_COGNITO_SCOPES;

const validateConfig = () => {
	const missing = [];
	if (!COGNITO_DOMAIN) missing.push("VITE_COGNITO_DOMAIN");
	if (!CLIENT_ID) missing.push("VITE_COGNITO_CLIENT_ID");
	if (!REDIRECT_URI) missing.push("VITE_COGNITO_REDIRECT_URI");
	if (!LOGOUT_URI) missing.push("VITE_COGNITO_LOGOUT_URI");
	if (!SCOPES) missing.push("VITE_COGNITO_SCOPES");

	if (missing.length > 0) {
		console.warn(
			`Cognito is not fully configured. Missing: ${missing.join(", ")}. ` +
				`SSO login will not work until these are set.`,
		);
		return false;
	}
	return true;
};

// If Cognito finds a session, it sends the user back to /callback.
// If not, it immediately returns an error to /callback.
export const buildSilentAuthUrl = () => {
	if (!validateConfig()) return null;

	const params = new URLSearchParams({
		response_type: "code",
		client_id: CLIENT_ID,
		redirect_uri: REDIRECT_URI,
		scope: SCOPES,
		prompt: "none",
	});

	return `${COGNITO_DOMAIN}/oauth2/authorize?${params.toString()}`;
};

export const buildLoginUrl = () => {
	if (!validateConfig()) return null;

	const params = new URLSearchParams({
		response_type: "code",
		client_id: CLIENT_ID,
		redirect_uri: REDIRECT_URI,
		scope: SCOPES,
	});

	return `${COGNITO_DOMAIN}/oauth2/authorize?${params.toString()}`;
};

export const buildLogoutUrl = () => {
	if (!validateConfig()) return null;

	const params = new URLSearchParams({
		client_id: CLIENT_ID,
		logout_uri: LOGOUT_URI,
	});

	return `${COGNITO_DOMAIN}/logout?${params.toString()}`;
};

export const isCognitoConfigured = () => validateConfig();
